import React, { Component } from "react";
import { injectIntl } from "react-intl"; // 国际化
import { connect } from "react-redux";
import { setLocaleConfig } from "@/state/action/comAction";
import "../../assets/stylus/select_company.styl";
import { refreshTokenApi, getCompanyListApi } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import { Row, Col, message } from "antd";
import Pagination from "./Pagination";
import Tool from "../../utils/Tool";
@connect((state) => state, { setLocaleConfig })
class SelectCompany extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.lang = this.props.appLocalInfo.locale;
    let language = null;
    if (this.props.intl.locale === "zh") {
      language = "中文";
    } else if (this.props.intl.locale === "en") {
      language = "英文";
    } else if (this.props.intl.locale === "es") {
      language = "西班牙语";
    }
    this.state = {
      account: window.sessionStorage.getItem("userAccount") || Tool.getUrlParam("name"),
      language: language,
      selectedCompany: "",
      selectedArea: "",
      companyList: [],
      pagination: {
        pageSize: 4,
        current: 1,
      },
    };
    this.getUserInfo();
  }

  // 根据token得到用户信息
  getUserInfo = () => {
    if (Tool.getUrlParam("token")) {
      // console.log("-------钉钉回调-------");
      // 钉钉扫码成功后 回调url跳转过来的
      window.sessionStorage.setItem("token", Tool.getUrlParam("token"));
      this.fetchCompanyList();
    } else {
      if (window.sessionStorage.getItem("token")) {
        // console.log("------不是钉钉回调--只是选择公司，不管从哪里来的-----");
        // 登陆跳转过来的，或者之前有token
        this.fetchCompanyList();
      } else {
        this.props.history.push("/login");
      }
    }
  };

  // 拉取公司列表
  fetchCompanyList = async () => {
    const res = await fetchHandler(getCompanyListApi);
    const companyList = res.data;
    this.setState({ companyList: companyList });
    if (companyList.length === 0) {
      console.log("您没有公司");
    } else if (companyList.length === 1) {
      this.onSelectCompany(companyList[0]);
    }
  };

  // 选择公司
  onSelectCompany = (company) => {
    window.sessionStorage.setItem("companyId", company.id);
    window.sessionStorage.setItem("companyName", company.name);

    this.setState(
      {
        selectedCompany: company,
        selectedArea: { id: "" },
      },
      () => {
        this.refreshToken();
      },
    );
  };

  // 选择地区
  onSelectArea = (area) => {
    this.setState({ selectedArea: area }, () => {
      this.setState({ selectedArea: area });
      this.refreshToken();
    });
  };

  // 选择地区刷新token
  refreshToken = async () => {
    const { selectedCompany, selectedArea } = this.state;
    // console.log('selectedCompany:',selectedCompany,'selectedArea:',selectedArea);
    const res = await fetchHandler(refreshTokenApi, {
      companyId: selectedCompany.id,
      regionId: selectedArea.id || "",
      source: "pc",
    });
    // console.log('refreshTokenApiData:',res.data);
    if (res.code === "success") {
      window.sessionStorage.setItem("token", res.data.token);
      window.sessionStorage.setItem("name", res.data.userName);
      window.sessionStorage.setItem("userId", res.data.ctUserId);
      window.sessionStorage.setItem("role", res.data.role);
      window.sessionStorage.setItem("userAccount", res.data.userAccount);
      window.sessionStorage.setItem("xxFlag", res.data.xxFlag);
      window.sessionStorage.setItem("infoTypeSet", JSON.stringify(res.data.infoTypeSet));
      //调整顺序：地锁查询放到设备查询下面
      // console.log(
      //   "SelectCompany:",
      //   res.data.menuList,
      //   "===",
      //   window.sessionStorage.getItem("companyId"),
      //   window.sessionStorage.getItem("companyName"),
      // );

      if (res.data.menuList && res.data.menuList.length > 0) {
        for (var i = 0; i < res.data.menuList.length; i++) {
          if (res.data.menuList[i].cname == "配置管理") {
            let subs = [];
            let lock = null;
            let index = -1;
            let indexs = -1;
            //调整地锁查询到设备和电站查询下面
            for (var j = 0; j < res.data.menuList[i].childList.length; j++) {
              if (res.data.menuList[i].childList[j].cname != "地锁查询") {
                subs.push(res.data.menuList[i].childList[j]);
                if (res.data.menuList[i].childList[j].cname == "设备快速查询") {
                  index = subs.length;
                }
                if (res.data.menuList[i].childList[j].cname == "电站列表") {
                  indexs = subs.length;
                }
              } else {
                lock = res.data.menuList[i].childList[j];
              }
            }
            if (lock != null) {
              subs.splice((index = -1 ? indexs + 1 : index + 1), 0, lock);
            }
            res.data.menuList[i].childList = subs;
          }
        }
      }

      window.sessionStorage.setItem("menulist", JSON.stringify(res.data.menuList));
      // 增加检查菜单权限判断
      if (Array.isArray(res.data.menuList) && res.data.menuList.length > 0) {
        this.props.history.push("/index");
      } else {
        message.error("您暂无权限");
      }
    }
  };

  // 点击空白
  onClickBlankArea = () => {
    // console.log("---onClickBlankArea---");
    this.setState({ selectedCompany: {} });
  };

  // 公司分页变化
  getCurrentCompanyList = () => {
    const {
      companyList,
      pagination: { pageSize, current },
    } = this.state;
    return [...companyList].splice(pageSize * (current - 1), pageSize);
  };

  

  render() {
    const { companyList, selectedCompany, pagination, account } = this.state;
    return (
      <div id="selectCompanyPage" onClick={this.onClickBlankArea}>
        {/* logo和账号 */}
        <div className="logo_account_wrap">
          <div className="logo"></div>
          <div className="account">
            <div>账号：</div>
            <div>{account}</div>
            <div
              className="logout"
              onClick={() => {
                window.sessionStorage.removeItem("token");
                window.sessionStorage.removeItem("name");
                window.sessionStorage.removeItem("omc-token");
                window.sessionStorage.removeItem("omc-username");
                window.sessionStorage.removeItem("omc-userId");
                window.sessionStorage.removeItem("userId");
                window.sessionStorage.removeItem("userAccount");
                window.sessionStorage.removeItem("role");
                window.sessionStorage.removeItem("sso_code");
                this.props.history.push("/login");
              }}>
              退出
            </div>
          </div>
        </div>
        {/* 公司列表 */}
        <Row className="company_wrap" gutter={24}>
          {this.getCurrentCompanyList().map((company) => {
            return (
              <Col span={6} key={company.id}>
                <div
                  className={`company ${selectedCompany.id === company.id ? "active" : ""}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    this.onSelectCompany(company);
                  }}>
                  <div className="avatar" />
                  <div className="name">{company.name}</div>
                  <div className="role">{company.role}</div>
                </div>
              </Col>
            );
          })}
        </Row>
        {/* 公司的区域列表 */}
        {selectedCompany.list && selectedCompany.list.length > 0 && (
          <div className="sub_area_wrap">
            {selectedCompany.list.map((area) => {
              return (
                <div key={area.id} className="area">
                  <div className="name">{area.name}</div>
                  <a
                    className="click"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.onSelectArea(area);
                    }}>
                    点击进入
                  </a>
                </div>
              );
            })}
          </div>
        )}
        {/* 公司分页区域 */}
        {(!selectedCompany.list || selectedCompany.list.length === 0) &&
          companyList.length > pagination.pageSize && (
            <div className="company_pagination_wrap">
              <Pagination
                {...pagination}
                total={companyList.length}
                onChange={(current) => {
                  // console.log(current);
                  this.setState({
                    pagination: { ...pagination, current },
                  });
                }}
              />
            </div>
          )}
        <div className="sc-oms-footer-login" style={{ lineHeight: "20px" }}>
          COPYRIGHT &copy;2018 万帮星星充电科技有限公司 All rights reserved.
          <br />{" "}
          <a
            style={{ color: "#fff" }}
            onClick={() => {
              window.open("http://beian.miit.gov.cn/");
            }}>
            苏ICP备14056214号-3{" "}
          </a>{" "}
          版本号：{process.env.REACT_APP_VERSION}
        </div>
      </div>
    );
  }
}

export default injectIntl(SelectCompany);



// WEBPACK FOOTER //
// ./src/AntD/pages/SelectCompany/SelectCompany.js